import { HeaderBuilder } from '@platform/http/blocs/services/header-builder';

const pepperHeaders = async (): Promise<Record<string, string>> => {
  try {
    return await HeaderBuilder.create().withAuth().build();
  } catch {
    return HeaderBuilder.create().build();
  }
};

export const withPepperHeaders = async (
  init: RequestInit,
): Promise<RequestInit> => ({
  ...init,
  headers: {
    ...(await pepperHeaders()),
    ...(init.headers as Record<string, string> | undefined),
  },
});
